import React from 'react'

const MailIcon = (
  <svg
    aria-hidden="true"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.666504 7V12.6667C0.666504 13.0203 0.80698 13.3594 1.05703 13.6095C1.30708 13.8595 1.64622 14 1.99984 14H13.9998C14.3535 14 14.6926 13.8595 14.9426 13.6095C15.1927 13.3594 15.3332 13.0203 15.3332 12.6667V7"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.3332 4.66667V3.33333C15.3332 2.97971 15.1927 2.64057 14.9426 2.39052C14.6926 2.14048 14.3535 2 13.9998 2H1.99984C1.64622 2 1.30708 2.14048 1.05703 2.39052C0.80698 2.64057 0.666504 2.97971 0.666504 3.33333V4.66667L7.99984 9.33333L15.3332 4.66667Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default MailIcon
